module.exports = __webpack_public_path__ + "img/75011c5.jpg";